<template>
  <div class="dashboard-card">
    <v-card class="actual-card">
      <template v-if="loading">
        <v-card-text >
          Loading...
        </v-card-text>
      </template>
      <template v-if="!loading">
        <v-card-title>
          Your&nbsp;<span style="overflow-wrap: break-word">{{ contactTitle }}</span>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <div>{{alpsDashboard.producerName}}</div>
            <div v-if="phoneNumber">
              <a :href="`tel:${alpsDashboard.producerPhone}`">{{phoneNumber}}</a>
            </div>
            <div>{{alpsDashboard.producerEmail}}</div>
            <div class="profile-pic-section">
              <v-img
                  v-if="!imageFailed && alpsDashboard.alpsPicture"
                  :src="alpsDashboard.alpsPicture"
                  @error="contactImageError($event)"
              />
              <v-img v-else src="/profile-pics/default.svg"></v-img>
            </div>
          </div>
          <div class="mt-3">
            Your ALPS LPL and related policies expire on {{ lplExpirationDisplay }}
            <v-progress-linear v-if="alpsDashboard.lplProgressBarPercent" striped height="10" color="primary"
                               v-model="alpsDashboard.lplProgressBarPercent"
            ></v-progress-linear>
          </div>
        </v-card-text>
        <v-card-actions>
          <a v-if="meetingLinkUrl" :href="meetingLinkUrl" target="_blank">
            <v-btn outlined color="primary">Schedule a Meeting</v-btn>
          </a>

          <v-spacer />
          <v-btn outlined color="primary" @click="goToCommunications">Contact Me</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {formatPhoneForDisplay} from "@/components/forms/maska-masks";
import {COMMUNICATIONS} from "@/router/route-names";
import * as dateFn from 'date-fns'

export default {
  props: {
    profilePicture: {
      type: String,
      required: false,

    }
  },
  async mounted () {
    await this.getAlpsDashboard();
    this.loading = false
  },
  data: () => {
    return {
      loading: true,
      alpsDashboard: {
        alpsFirmName: undefined,
        producerName: undefined,
        producerEmail: undefined,
        producerPhone: undefined,
        alpsPicture: undefined,
        lplExpirationDate: undefined,
        lplProgressBarPercent: undefined,
      },
      imageFailed: false,
    }
  },
  computed: {
    ...mapGetters({
    }),
    phoneNumber() {
      if (this.alpsDashboard.producerPhone) {
        return formatPhoneForDisplay(this.alpsDashboard.producerPhone)
      }
      return undefined
    },
    contactTitle() {
      return 'Account Manager'
    },
    accountCode() {
      return this.$route.params.accountId
    },
    lplExpirationDisplay() {
      if (this.alpsDashboard.lplExpirationDate) {
        return dateFn.format(dateFn.parseISO(this.alpsDashboard.lplExpirationDate), 'MM/dd/yyyy')
      }
      return undefined
    },
    // https://www.alpsinsurance.com/meetings/alps-megratzburg/schedule
    meetingLinkUrl() {
      if (!this.alpsDashboard.producerName) {
        return undefined
      }
      const names = this.alpsDashboard.producerName.split(' ')
      if (names.length < 2) {
        console.log('Producer Name must have first and last name')
        return undefined
      }
      const firstName = names[0]
      const lastName = names[1]

      const normalizedLastName = lastName.replace(' ', '-')
      const url = `https://www.alpsinsurance.com/meetings/alps-${firstName.toLowerCase()}${normalizedLastName.toLowerCase()}/schedule`

      return url
    },
  },
  methods: {
    async getAlpsDashboard() {
      try {
        const url = `/api/accounts/${this.accountCode}/alps/dashboard`
        const resp = await this.$http.get(url)
        this.alpsDashboard = resp.data
      } catch (e) {
        console.error('Could not load Alps')
      }
    },
    contactImageError() {
      this.imageFailed = true
    },
    scheduleMeeting() {
      console.log('Schedule Meeting')
      window.open(this.meetingLink, '_blank')
    },
    goToCommunications() {
      this.$router
          .push({
            name: COMMUNICATIONS,
            params: { accountId: this.accountCode },
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {})
    },
  },
}
</script>
<style scoped lang="scss">
.profile-pic-section {
  max-width: 120px;
  max-height: 120px;
  margin-left: auto;
  margin-right: auto;
  .v-image {
    margin-top: 5px;
    max-width: 120px;
    max-height: 120px;
    border-radius: 50%;
  }
}
@import '~@/scss/variables';
.dashboard-card {
  height: 100%;
}
.actual-card {
  &.v-card {
    height: 100%;
    min-height: 318px;
  }
  .v-card__text {
    padding-bottom: 3rem;

    overflow-y: auto;
  }
  .v-card__actions {
    background-color: white;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>